import { Routes } from '@angular/router';
import { ExternalComponent } from './external.component';
import { DocuSignValidateComponent } from './components/docsign-validate/docusign-validate.component';

export const externalRoutes: Routes = [
  {
    path: '',
    component: ExternalComponent,
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'home',
        loadComponent: () =>
          import('../../pages/home/home.component').then(
            (x) => x.HomeComponent,
          ),
      },
      {
        path: 'products',
        loadComponent: () =>
          import('../../pages/product/product-list/product-list.component').then(
            (x) => x.ProductListComponent,
          ),
      },
      {
        path: 'products/details/:id',
        loadComponent: () =>
          import('../../pages/product/product-details/product-details.component').then(
            (x) => x.ProductDetailsComponent,
          ),
      },
      {
        path: 'terms-of-use',
        loadComponent: () =>
          import('../../pages/terms-of-use/terms-of-use.component').then(
            (x) => x.TermsOfUseComponent,
          ),
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('../../pages/privacy-policy/privacy-policy.component').then(
            (x) => x.PrivacyPolicyComponent,
          ),
      },
      {
        path: 'docusign-validate/:contractId',
        component: DocuSignValidateComponent,
      },
    ],
  },
];
